import {axiosInstance, getAuthToken}  from "../utils/Client";

export default class RevenueGoalService {
    
    static getRevenueTarget = (profileId) => {
        return axiosInstance.get(`/revenue_target/${profileId}/`,
            {
                headers: {
                    Authorization: getAuthToken()
                }
            }
        );
    };

    static getRevenueTargetReport = (profileId) => {
        return axiosInstance.get(`/revenue_target/report/${profileId}/`,
            {
                headers: {
                    Authorization: getAuthToken()
                }
            }
        );
    };

    static plList = async (locationId) => {
        return await axiosInstance.get(`/pl/list/${locationId}/`,
            {
                headers: {
                    Authorization: getAuthToken()
                }
            }
        );
    };
}



// WEBPACK FOOTER //
// ./src/services/RevenueGoalService.js